<template>
  <el-dialog
    title="权限设置"
    :visible.sync="permissionsVisible"
    :before-close="handleCancel"
    width="550px"
  >
    <div class="permissions-setting">
      <div class="label">
        设置角色：
      </div>
      <div class="setting">
        <el-select
          v-model="setRoleData"
          placeholder="请选择"
          class="select"
          @change="setRolechange"
        >
          <el-option
            v-for="item in setRoleList"
            :key="item.role_id"
            :label="item.role_name"
            :value="item.role_id"
          />
        </el-select>
        <div class="setting-tips">
          <span v-if="roleStr === '管理员'">拥有系统全部权限</span>
          <span v-if="roleStr === '普通员工'">无系统任何权限，无法登陆系统</span>
        </div>
      </div>
    </div>
    <span
      slot="footer"
      class="dialog-footer"
    >
      <el-button @click="handleCancel">取 消</el-button>
      <el-button
        type="primary"
        @click="submitRole"
      >确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  name: 'SpSetRole',
  model: {
    prop: 'permissionsVisible',
    event: 'permissionsVisibleChange'
  },
  props: {
    permissionsVisible: {
      type: Boolean,
      default: false
    },
    updateItem: {
      type: Object
    }
  },
  data () {
    return {
      setRoleList: [],
      setRoleData: '',
      roleStr: ''
    }
  },
  watch: {
    permissionsVisible (newValue) {
      if (newValue) {
        this.getRolesList()
      }
    }
  },
  mounted () {},
  methods: {
    // 获取角色列表
    async getRolesList () {
      const data = await this.$api.setting.getRolesList({
        page: 1,
        page_size: 1000
      })
      if (data) {
        this.setRoleList = data.list.filter((v) => v.role_name !== '超级管理员')
      }
    },
    // 修改用户角色
    async submitRole () {
      let userId = this.updateItem.user_id
      const data = await this.$api.setting.updateRole(userId, {
        role: [this.setRoleData]
      })
      if (data) {
        this.$emit('refresh')
        this.$message({
          message: '修改成功',
          type: 'success'
        })
        this.handleCancel()
      }
    },

    setRolechange (item) {
      let role_str = this.setRoleList.filter((v) => v.role_id === item)
      this.roleStr = role_str[0].role_name
    },

    handleCancel () {
      this.$emit('permissionsVisibleChange', false)
    }
  }
}
</script>

<style lang="scss" scoped>
// 权限设置
.permissions-setting {
  display: flex;
  justify-content: center;
  .label {
    line-height: 36px;
  }
  .setting {
    .select {
      width: 300px;
    }
    .setting-tips {
      color: #909399;
      font-size: 12px;
      margin-top: 10px;
    }
  }
}
</style>
